import { HTTP_STATUS_CODES } from '@@constants/http';

export const INTERNAL_SERVER_ERROR = 'Internal Server Error';
export const CONSTRAINT_ERROR = 'Validation failed';

export const NOT_AUTHORIZED_STATUSCODE = HTTP_STATUS_CODES.UNAUTHORIZED;
export const PRECONDITION_FAILED_STATUSCODE = HTTP_STATUS_CODES.PRECONDITION_FAILED;
export const BAD_REQUEST = HTTP_STATUS_CODES.BAD_REQUEST;
